module.exports = __webpack_public_path__ + "static/studio-4-e064d0908dbd53b55f8980c02b3748bb.jpg";